import React, { FC } from "react";

import { SolutionCard, StrengthCard, ChallengeCards, ActionCard } from "../../../atoms";
import { CardType } from "../../../../util/enums";
import { ICard } from '../../../../interfaces';

interface CardProps {
    cardData: ICard;
    isForceHoverOn?: boolean;
    solutionCardsInHands?: boolean;
    fullScreenIsOn?: boolean;
}

const FrontSide: FC<CardProps> = ({ cardData, isForceHoverOn, solutionCardsInHands, fullScreenIsOn }) => {

    const renderCardType = () => {
        if (!cardData) return;

        if (cardData.type === CardType.STRENGTH)
            return <StrengthCard cardData={cardData} />

        if (cardData.type === CardType.ACTION)
            return <ActionCard cardData={cardData} />

        if (cardData.type === CardType.QUESTION)
            return <ChallengeCards cardData={cardData} />

        return <SolutionCard cardData={cardData} displayExchangeButton isForceHoverOn={isForceHoverOn} solutionCardsInHands={solutionCardsInHands} fullScreenIsOn={fullScreenIsOn} />
    };

    return (
        <React.Fragment>
            {renderCardType()}
        </React.Fragment>
    );
};

export default FrontSide;
